import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__top">
          <div className="footer__brand">
            <span className="footer__logo">🍴 Recipe<strong>Sense</strong></span>
            <p>Save, organize and cook your favorite recipes.</p>
          </div>
          <div className="footer__links">
            <div className="footer__col">
              <h4>Recipes</h4>
              <Link to="/search?category=breakfast">Breakfast</Link>
              <Link to="/search?category=lunch">Lunch</Link>
              <Link to="/search?category=dinner">Dinner</Link>
              <Link to="/search?category=desserts">Desserts</Link>
            </div>
            <div className="footer__col">
              <h4>Ingredients</h4>
              <Link to="/search?q=chicken">Chicken</Link>
              <Link to="/search?q=beef">Beef</Link>
              <Link to="/search?q=pasta">Pasta</Link>
              <Link to="/search?q=vegetables">Vegetables</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {year} RecipeSense. All rights reserved.</span>
          <div className="footer__legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
